var _defs, _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "offers_icon",
    "data-name": "offers icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M0,20A20,20,0,1,1,20,40,20,20,0,0,1,0,20Z",
    fill: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    width: 24,
    height: 24,
    transform: "translate(8 8)",
    fill: "rgba(255,255,255,0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask-2",
    "data-name": "Mask",
    d: "M0,20A20,20,0,1,1,20,40,20,20,0,0,1,0,20Z",
    fill: "#F6F6F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Background-2",
    "data-name": "Background",
    width: 24,
    height: 24,
    transform: "translate(8 8)",
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "offers_icon-3",
    "data-name": "offers icon",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(11 10.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M2.971,1.95H16.039V1.01A1.011,1.011,0,0,0,15.027,0H1.01A1.01,1.01,0,0,0,0,1.01V15.052a1.01,1.01,0,0,0,1.01,1.01h.951V2.962A1.011,1.011,0,0,1,2.971,1.95Z",
    fill: "#44A6E0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_Union",
    "data-name": "Shape Union",
    d: "M.88,14A.88.88,0,0,1,0,13.119V.881A.882.882,0,0,1,.88,0H13.1a.883.883,0,0,1,.882.881V12.989A1.01,1.01,0,0,1,12.967,14Z",
    transform: "translate(4.021 4.013)",
    fill: "#0270B2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    "data-name": "Group",
    transform: "translate(16.918 15.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M4.418.5a.479.479,0,0,1-.455.5H.457A.481.481,0,0,1,0,.5H0A.48.48,0,0,1,.457,0H3.963a.479.479,0,0,1,.455.5Z",
    transform: "translate(0 2.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M8.836.5a.48.48,0,0,1-.457.5H.457A.48.48,0,0,1,0,.5H0A.481.481,0,0,1,.457,0H8.379a.481.481,0,0,1,.457.5Z",
    transform: "translate(0 6.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M8.836.5a.48.48,0,0,1-.457.5H.457A.481.481,0,0,1,0,.5H0A.48.48,0,0,1,.457,0H8.379a.48.48,0,0,1,.457.5Z",
    transform: "translate(0 9.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M5.376,1.409l-2.691,2.7a.793.793,0,0,1-.268.179.814.814,0,0,1-.318.064.8.8,0,0,1-.316-.064.792.792,0,0,1-.27-.179L.24,2.9a.837.837,0,0,1,0-1.173.774.774,0,0,1,.268-.184.822.822,0,0,1,.636,0,.783.783,0,0,1,.268.184l.625.624,2.1-2.1A.888.888,0,0,1,4.407.064.824.824,0,0,1,4.727,0a.807.807,0,0,1,.586.249.783.783,0,0,1,.2.254.83.83,0,0,1,.082.312.838.838,0,0,1-.047.319.81.81,0,0,1-.171.275Z",
    transform: "translate(5.727)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon);
export default __webpack_public_path__ + "static/media/offer-icon.159bb34a031349075719cbdec917ec9b.svg";
export { ForwardRef as ReactComponent };